export default questions => _.orderBy(
  Object.values(_.groupBy(questions, "module_id"))
  .map(group => ({ ...group[0], questions: group })),
  ['module_order'], ['asc']
)
